import { render } from "./SearchSection.vue?vue&type=template&id=35297ba7&scoped=true&ts=true"
import script from "./SearchSection.vue?vue&type=script&lang=ts"
export * from "./SearchSection.vue?vue&type=script&lang=ts"

import "./SearchSection.vue?vue&type=style&index=0&id=35297ba7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35297ba7"]])

export default __exports__